import { AppBar, AppBarProps, Toolbar, alpha, styled } from '@mui/material';
import React from 'react';

interface PrimaryNavBarProps extends AppBarProps {
  position?: 'fixed' | 'absolute' | 'sticky' | 'static' | 'relative';
  gradient?: boolean;
  width?: string;
}

const StyledNavBar = styled(AppBar)<PrimaryNavBarProps>(({ theme, position, width }) => ({
  position: position,
  width: width,
  boxShadow: 'none',
  transition: theme.transitions.create(['width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  })
}));

const StyledToolBar = styled(Toolbar, {
  shouldForwardProp: (prop: string) => prop !== 'gradient'
})<PrimaryNavBarProps>(({ theme, gradient }) => ({
  background: gradient
    ? `linear-gradient(to right, ${theme.palette.primary.main} 60%, #ffffff 75%)`
    : theme.palette.primary.main,
  borderBottom: gradient ? `1px solid ${alpha(theme.palette.secondary.main, 0.3)}` : 'none'
}));

/**
 * Standard navigation bar to be used for logged in and out app states.
 * @param {React.ReactNode} children Child elements within Nav Bar.
 * @param {'fixed' | 'absolute' | 'sticky' | 'static' | 'relative' | undefined} position Optional sstyling position of navbar.
 * @param {string | undefined} width Optionally set a custom width of the Nav Bar.
 * @returns {JSX.Element}
 */
const PrimaryNavBar = ({
  children,
  ...props
}: PrimaryNavBarProps & { children: React.ReactNode }) => {
  return (
    <StyledNavBar position={props.position} width={props.width}>
      <StyledToolBar gradient={props.gradient} disableGutters sx={{ px: { xs: 2, md: 4 } }}>
        {children}
      </StyledToolBar>
    </StyledNavBar>
  );
};

export default PrimaryNavBar;
